import {LanguageOption, SimplifiedAgreement} from "common/common-models";
import {IElectricityAgreement, MeteringPoint} from "components/ElectricityAgreements/models";
import moment from "moment";
import React from "react";

/* eslint-disable no-useless-escape */
export const getParams = (search: string) => {
    let params: { [key: string]: string | null } = {};
    if (search) {
        const match = search.match(/(\?|&)[a-zA-Z0-9]+(=)[a-zA-Z0-9._\-]+/g);
        if (match) {
            match.map((x: string) => x.substring(1, x.length).split('=')).forEach(x => {
                params[x[0]] = x[1] === 'null' ? null : x[1];
            });
        }
    }
    return params;
}

export const fromHexString = (hexString: string) =>
    new Uint8Array((hexString.match(/.{1,2}/g) || []).map((byte: string) => parseInt(byte, 16)));

export const toHexString = (bytes: Uint8Array) =>
    bytes.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');

export const base64ToByteArray = (base64: string) => {
    var binaryString = atob(base64);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}

export const hexToBase64 = (hex: string) => {
    return btoa(hex.match(/\w{2}/g)!.map(function (a) {
        return String.fromCharCode(parseInt(a, 16));
    }).join(""));
}

export const isMobileDevice = () => {
    let check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

export const handleTextInputNumberChange = (oldValue: string, newValue: string) => {
    if (!newValue) {
        return '';
    }
    return isNaN(parseInt(newValue, 10)) ? oldValue : newValue;
}

export function roundNumber(value: number, roundTo: number): number {
    return Math.round(value * Math.pow(10, roundTo)) / Math.pow(10, roundTo);
}

export const validateAgreement = (agreement: IElectricityAgreement) => {
    if (
        !!agreement.startDate &&
        moment(agreement.startDate).isBefore(moment()) &&
        !agreement.hasLastMonthsInvoice
    ) {
        const dateToCompare = moment().subtract(1, 'months').startOf('month');
        if (agreement.endDate && moment(agreement.endDate).isBefore(dateToCompare)) {
            return false;
        }
        return true;
    }
    return false;
}

export const getEarliestPossibleAgreementStartDate = (meteringPoints: MeteringPoint[]): Date => {
    const checkedMeteringPoints = meteringPoints.filter(mp => mp.checked);
    const currentDate = moment();

    const meteringPointWithEarliestDate = checkedMeteringPoints.sort(
        (a, b) => b.earliestPossibleAgreementStartDate.localeCompare(a.earliestPossibleAgreementStartDate))[0];

    if (!meteringPointWithEarliestDate) {
        return currentDate.toDate();
    }

    const earliestPossibleDate = moment(meteringPointWithEarliestDate.earliestPossibleAgreementStartDate);

    if (currentDate.isAfter(earliestPossibleDate)) {
        return currentDate.toDate();
    }

    return earliestPossibleDate.toDate();
}

export const translateCreateInvoiceError = (message: string | null) => {
    let errorMessage;

    switch (true) {
        case message === null:
            errorMessage = 'Vea sõnumit ei ole!';
            break;
        case message!.includes("Not all required metering points are assigned to invoice groups"):
            errorMessage = "Kliendil on arvegrupita mõõtepunkte";
            break;
        case message!.includes("Lepinguga seotud kontaktisikut ei leitud"):
            errorMessage = "Contact person not found for agreements";
            break;
        case message!.includes("No measurement data"):
            errorMessage = "Mõõteandmed puuduvad";
            break;
        case message!.includes("Failed to create Merit client"):
            errorMessage = "Merit kliendi loomine ebaõnnestus";
            break;
        case message!.includes("Customer has not given authorization"):
            errorMessage = "Õigused eleringis päringute tegemiseks puuduvad";
            break;
        case message!.includes("update.request.email: must not be blank"):
            errorMessage = "Kliendil puudub email";
            break;
        case message!.includes("No Grid Invoices found without an associated Invoice for Metering Point"):
            errorMessage = "Elektrilevi arve puudub";
            break;
        case message!.includes("Synchronization is currently in progress"):
            errorMessage = "Arvete sünk on pooleli";
            break;
        case message!.includes("Invoice creation failed for non consolidated agreement"):
            errorMessage = "Üks või mitu mõõtepunkti ebaõnnestus";
            break;
        case message!.includes("Failed to create Finbite Invoice"):
            errorMessage = "Finbite arve loomine ebaõnnestus";
            break;
        case message!.includes("Failed to delete Merit Invoice"):
            errorMessage = "Meriti arve kustutamine ebaõnnestus";
            break;
        case message!.includes("Failed to sync invoice debts for Customer"):
            errorMessage = "Meriti ettemaksu sünk ebaõnnestus";
            break;
        case message!.includes("Missing city from customer"):
            errorMessage = "Kliendil puudub linn";
            break;
        case message!.includes("Finbite preference sync failed"):
            errorMessage = "Finbite eelistuste sünk ebaõnnestus";
            break;
        case message!.includes("Too many requests"):
            errorMessage = "Meriti päringute limiit täis";
            break;
        default:
            errorMessage = "Serveri viga";
            break;
    }

    return errorMessage;
}

export const getImageProperty = (lang: LanguageOption) => {
    return lang === LanguageOption.EN ? "imageEn" : "imageEt"
}

export const normalizeCommaSeperatedEmail = (email?: string) => {
    if (!email) return email;

    return email.split(",").map(email => email.trim()).join(",");
}

export function redirectToLogin() {
    window.location.replace(`${process.env.REACT_APP_ADMIN_URL}/login`);
}

export const getLastMonthWithFirstDay = () => {
    return moment().subtract(1, 'month').startOf('month').format('DD.MM');
}

export const getLastMonthWithLastDay = () => {
    return moment().subtract(1, 'month').endOf('month').format('DD.MM');
}

export const getMarketPricePackageProductDescription = (name: string | undefined) => {
    return `Elektri ${name ? name.toLocaleLowerCase() : ''}`
}

export const startDateInFuture = (date: string) => {
    return moment(date).isAfter(moment())
}

export type FormControlElement = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

export const onNumberChange = (e: React.ChangeEvent<FormControlElement>): number | undefined => {
    const value = e.target.value;
    const parsedValue = parseFloat(value);

    if (value === "" || Number.isNaN(parsedValue)) return undefined;
    return parsedValue;
};

export const getMeteringPointWarningMessage = (relatedAgreement?: SimplifiedAgreement) => {
    if (!relatedAgreement)
        return null

    const identifier = relatedAgreement.isElectricity ? "elektri" : "laadimis";

    if (relatedAgreement.startDate === null)
        return <div className="font-weight-normal text-danger">Mõõtepunkt on juba seotud {identifier}lepinguga, mis on
            kinnitamise ootel!</div>;

    return (
        <div className="font-weight-normal text-warning">
            Mõõtepunkt on juba
            seotud {startDateInFuture(relatedAgreement.startDate) ? "tulevikus algava" : "aktiivse"} {identifier}lepinguga!
        </div>
    );
}
